import { render } from "./Factura.vue?vue&type=template&id=35fd6da4&scoped=true"
import script from "./Factura.vue?vue&type=script&lang=js"
export * from "./Factura.vue?vue&type=script&lang=js"

import "./Factura.vue?vue&type=style&index=0&id=35fd6da4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35fd6da4"]])

export default __exports__